import React from 'react'

import Carousel from 'react-multi-carousel';

const CarruselSinDescripcion = ({imgs}) => {
    const responsive = {
        desktop: {
          breakpoint: { max: 3000, min: 0 },
          items: 1,
          paritialVisibilityGutter: 0
        }
    };

    return (
        <div className="contenedor-carrusel">
            <Carousel
              ssr
              partialVisbile
              showDots
              itemClass="image-item"
              autoPlaySpeed={3000}
              responsive={responsive}
              draggable
            >
                {imgs.map((bloque, index) => (
                    <div key={index}>
                        <img 
                            src={bloque} 
                            style={{ objectFit: 'cover'}}
                            width="100%"
                            alt={`bloque-${index}`}
                        />
                    </div>
                ))}
            </Carousel>
        </div>
    )
}

export default CarruselSinDescripcion